export const UGA_PAGE_TITLE = "UGA Students — Premium Mastermind Membership";

export const UGA_PAGE_SEO_DESCRIPTION =
  "UGA I/O students: practical AI mental models, live cohort prototypes, lifetime Premium at 25% off.";

export const UGA_HERO_BADGE = "For UGA I/O students";

export const UGA_HERO_TITLE_LEAD = "Your I/O Training,";

export const UGA_HERO_TITLE_ACCENT = "Amplified by AI";

export const UGA_HERO_SUBHEAD =
  "You know selection, assessment, and org change. Learn to do that work faster with AI as a thinking partner.";

export const UGA_STORY_SECTION_EYEBROW = "For your I/O path";

export const UGA_STORY_SECTION_HEADLINE = "Why students join";

export const UGA_STORY_SECTION_SUBHEAD =
  "Three ways the Mastermind maps to what you are already learning.";

export const UGA_SECTIONS = [
  {
    title: "Learn faster than the field changes",
    body: "The skill is not prompting. It is pulling new knowledge into working memory fast and judging what holds up. You already read for construct validity; we give you mental models to interrogate a model output the same way.",
  },
  {
    title: "You will not be the only Dawg in the room",
    body: "Several members came from UGA, including leaders from the IOMP program. The room speaks your language: job analysis, change readiness, stakeholder buy-in. Peers juggling weekend classes and a full-time job, same as you.",
  },
  {
    title: "Build something real, not another deck",
    body: "Every live cohort ships working prototypes, not slide decks. Members have walked into interviews and promotion conversations with something they built, not just a bullet point. Move fast without shipping work you cannot defend.",
  },
] as const;

export const UGA_FEATURE_GROUPS = [
  {
    label: "In your I/O work",
    items: [
      "Summarize selection and assessment research in minutes",
      "Stress-test surveys, interview guides, and competency models",
      "Prototype L&D content without a dev team",
      "Show a portfolio artifact when you interview",
    ],
  },
  {
    label: "In Premium",
    items: [
      "Live cohort sessions: build and ship a real prototype",
      "Coaching on your projects and career goals",
      "Lifetime access to cohorts, materials, and UGA peer community",
    ],
  },
] as const;

export const UGA_FEATURES_SECTION_BADGE = "Membership benefits";

export const UGA_FEATURES_SECTION_HEADLINE = "What you get";

export const UGA_FEATURES_SECTION_SUBHEAD =
  "Practical skills for your day job, plus Premium access when you are ready.";

export const UGA_NEIL_TRUST_AFTER_NAME =
  " instructed nearly 200 HR professionals as an adjunct professor at the University of Georgia.";

export const UGA_DISCOUNT_HEADLINE = "Student rate: 25% off lifetime access";

export const UGA_DISCOUNT_CTA = "Apply for your seat";

export const UGA_DISCOUNT_BODY_MIDDLE =
  " for lifetime membership. UGA students pay ";

export const UGA_DISCOUNT_BODY_CODE = " with code ";

export const UGA_DISCOUNT_BODY_SUFFIX =
  ". Apply first; enter the code at checkout once accepted.";
